import { createRouter, createWebHistory, RouteLocationNormalized, Router } from 'vue-router';
import routes from './routes';

const router: Router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior: (to: any, from: any, savedPosition: any) => {
		if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth',
			};
		}

		if (to.path === from.path && to.query !== from.query) {
			return false;
		}

		if (to.name && from.name && to.name === from.name) {
			return false;
		}

		if (savedPosition) {
			return savedPosition;
		}

		return {
			top: 0,
			behavior: 'smooth',
		};
	},
});

router.onError((error: any, to: RouteLocationNormalized) => {
	const isResolveError = (
		error.message?.indexOf('Couldn\'t resolve component "default" at') === 0 ||
		error.message?.indexOf('Failed to fetch dynamically imported module:') === 0
	);

	if (isResolveError && import.meta.env.VITE_ENV !== 'develop') {
		const resolveErrorsCount = parseInt(
			window.localStorage.getItem('resolve-errors') || '0',
			10,
		) + 1;

		window.localStorage.setItem('resolve-errors', '' + resolveErrorsCount);

		setTimeout(() => {
			if (resolveErrorsCount <= 3) {
				window.location.href = to.fullPath;
			} else {
				window.localStorage.removeItem('resolve-errors');
				window.location.href = '/';
			}
		}, 1000);
	}
});

export default router;
